import { render, staticRenderFns } from "./MemberCreateComponent.vue?vue&type=template&id=22aa7f1b&"
import script from "./MemberCreateComponent.vue?vue&type=script&lang=js&"
export * from "./MemberCreateComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberCreateComponent.vue?vue&type=style&index=0&id=22aa7f1b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports